import axios from "axios";
import { CancellationType } from "../enums";

interface Data {
  choice: CancellationType;
  source: string; // "APPROVAL" | "CANCELLATION";
}

export const saveCancellationChoice = async (
  tripUuid: string,
  bookingUuid: string,
  data: Data
) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/schedule-change/cancellation/${tripUuid}/${bookingUuid}/choice`,
      data,
      { timeout: 3000 }
    );
  } catch (error) {
    throw error;
  }
};
